import http from "./http";

export const createChat = (params = {}) =>
  http.post("support/chat-online/create/", params);

export const getSiteCustomerChatHistory = (storeId, mobile = {}) =>
  http.get(`support/chat-online/store/${storeId}/customer/`, {
    params: { mobile },
  });

export const getChatMyStores = (search) =>
  http.get(`support/chat-online/my-stores/`, { params: search });

export const getChatMessage = (chatId) =>
  http.get(`support/chat-online/${chatId}/messages/`);

export const sendChatMessage = (chatId, body) =>
  http.post(`support/chat-online/${chatId}/message/`, body);
